<!--
프린터 관리 컴포넌트
문서에 항상 삽입되어있고, 필요시 호출되는구조로 작동함.
-->
<template>
    <div>
        <find-printers ref="find-printers"></find-printers>
        <change-label ref="change-label"></change-label>
        <change-print-type ref="change-print-type"></change-print-type>

        <!-- iframe 처리중화면 blockui -->
        <overlay-loading ref="down-overlay">
            <div slot="dialog">
                <loading-icon></loading-icon>
                P R I N T I N G . . .
            </div>
        </overlay-loading>
    </div>
</template>

<script>

import {get_printer} from "../../../../classes/printer-manager";

// 출력데이터
import sample_pdf from "../data/sample-pdf";
import bl_png from "../data/bl-png";
import bl_pdf from "../data/bl-pdf";
import bl_zpl from "../data/bl-zpl";
import store_label_zpl from "../data/store-label-zpl";
import store_label_pdf from "../data/store-label-pdf";
import store_label_png from "../data/store-label-png";
import shipout_hold_label_zpl from "../data/shipout-hold-label-zpl";
import shipout_hold_label_pdf from "../data/shipout-hold-label-pdf";
import shipout_hold_label_png from "../data/shipout-hold-label-png";
//console.log(bl_pdf);

export default {
    components: {
        'find-printers': require('./find-printers.vue').default,
        'change-label': require('./change-label.vue').default,
        'change-print-type': require('./change-print-type.vue').default,
    },
    props: {
    },
    data: function () {
        return {

            // 하우스아이디로 지역ID조회하는부분 캐시처리
            cacheRegionIdsByHouse: {},

            // 상품아이디로 지역ID조회하는부분 캐시처리
            cacheRegionIdsByProd: {},
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        /**
         * 프린터 검색모듈 실행
         */
        findPrinters(region_id) {
            this.$refs['find-printers'].form(region_id);
        },

        /**
         * 라벨선택 실행
         */
        changeLabel(region_id) {
            this.$refs['change-label'].form(region_id);
        },

        /**
         * 출력방식 변경 실행
         */
        changePrintType(region_id) {
            this.$refs['change-print-type'].form(region_id);
        },

        /**
         * 송장출력
         * - 해당지역에 pdf출력이 허용된경우, pdf출력
         * - 아직 pdf출력이 존재하지 않으면 zpl 출력처리
         * @param region_id
         * @param house_id
         * @param blno 멀티송장의 경우, 특정한장만 출력할때 사용
         *
         */
        async printBl(region_id, house_id, blno) {
            if (! region_id) {
                region_id = await this.regionIdByHouse(house_id);
                //console.log(`region id is : ${region_id}`);
            }

            // pdf, zpl방식 얻어오기
            let printer = get_printer(region_id);
            //let print_data = bl_pdf;
            let print_data = bl_png;
            if (printer.printType === 'zpl') {
                print_data = bl_zpl;
            }


            //console.log(region_id, house_id);
            //console.log(print_data);


            // qz 데이터생성
            return print_data.makeQzDataPromise(house_id, blno, printer, this.$refs['down-overlay']).then((qz_data) => {
                //console.log('end!!', qz_data); return; // todo : 제거
                return printer.print(qz_data);
                //console.log(qz_data);

            });
        },

        /**
         * 보관라벨 출력
         *
         * @param region_id
         * @param prod_id
         *
         */
        async printStoreLabel(region_id, prod_id) {
            if (! region_id) {
                region_id = await this.regionIdByProd(prod_id);
                //console.log(`region id is : ${region_id}`);
            }

            // pdf, zpl방식 얻어오기
            let printer = get_printer(region_id);
            //let print_data = store_label_pdf;
            let print_data = store_label_png;
            if (printer.printType === 'zpl') {
                print_data = store_label_zpl;
            }


            // qz 데이터생성
            return print_data.makeQzDataPromise(prod_id, this.$refs['down-overlay']).then((qz_data) => {
                return printer.print(qz_data);
            });
        },

        /**
         * 출고보류라벨 출력
         *
         * @param region_id
         * @param house_id
         *
         */
        async printShipoutHoldLabel(region_id, house_id) {
            if (! region_id) {
                region_id = await this.regionIdByHouse(house_id);
                //console.log(`region id is : ${region_id}`);
            }

            // pdf, zpl방식 얻어오기
            let printer = get_printer(region_id);
            //let print_data = shipout_hold_label_pdf;
            let print_data = shipout_hold_label_png;
            if (printer.printType === 'zpl') {
                print_data = shipout_hold_label_zpl;
            }


            // qz 데이터생성
            return print_data.makeQzDataPromise(house_id, this.$refs['down-overlay']).then((qz_data) => {
                return printer.print(qz_data);
            });
        },

        /**
         * pdf 샘플출력(테스트용)
         *
         */
        printSamplePdf(region_id) {
            let printer = get_printer(region_id);
            let print_data = sample_pdf;

            // qz 데이터생성
            print_data.makeQzDataPromise().then((qz_data) => {
                return printer.print(qz_data);
                //console.log(qz_data);

            });
        },

        /**
         * 하우스번호로 지역ID반환
         *
         */
        async regionIdByHouse(house_id) {
            if (this.cacheRegionIdsByHouse[house_id]) {
                // 캐시처리
                return Promise.resolve(this.cacheRegionIdsByHouse[house_id]);
            }

            return fetch(`/houses/${house_id}/region-id`, {
                headers: {
                    "Accept": "application/json",
                },
            }).then((res) => {
                if (res.status !== 200) {
                    let msg = '출력정보를 불러올 수 없습니다.';
                    if (res.headers.has('gonelo-error-message-urlencoded')) {
                        msg = decodeURI(res.headers.get('gonelo-error-message-urlencoded'));
                    }
                    throw new Error(msg);
                }
                //console.log(res);

                return res.json();
            }).then((result) => {
                this.cacheRegionIdsByHouse[house_id] = result.region_id;
                return result.region_id;
            });
        },

        /**
         * 상품번호로 지역ID반환
         *
         */
        async regionIdByProd(prod_id) {
            if (this.cacheRegionIdsByProd[prod_id]) {
                // 캐시처리
                return Promise.resolve(this.cacheRegionIdsByProd[prod_id]);
            }

            return fetch(`/prods/${prod_id}/region-id`, {
                headers: {
                    "Accept": "application/json",
                },
            }).then((res) => {
                if (res.status !== 200) {
                    let msg = '출력정보를 불러올 수 없습니다.';
                    if (res.headers.has('gonelo-error-message-urlencoded')) {
                        msg = decodeURI(res.headers.get('gonelo-error-message-urlencoded'));
                    }
                    throw new Error(msg);
                }
                //console.log(res);

                return res.json();
            }).then((result) => {
                this.cacheRegionIdsByProd[prod_id] = result.region_id;
                return result.region_id;
            });
        },
    },// end methods
}
</script>

<style lang="scss" scoped>
</style>